/** godepth 式面包屑：「首页 › 段 › 页」，首页链接 sky 色。 */
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { HOME_PATH, SEGMENT_LABEL, matchRoute } from './registry';

export function Breadcrumb() {
  const { pathname } = useLocation();
  const r = matchRoute(pathname);
  if (!r?.segment) return null;
  return (
    <nav aria-label="位置" className="mb-3 flex items-center gap-1.5 text-sm">
      <Link to={HOME_PATH} className="font-medium text-sky-600 hover:underline dark:text-sky-400">首页</Link>
      <ChevronRight className="h-3.5 w-3.5 text-slate-400" />
      <span className="text-slate-500 dark:text-slate-400">{SEGMENT_LABEL[r.segment]}</span>
      <ChevronRight className="h-3.5 w-3.5 text-slate-400" />
      <span className="font-medium text-foreground">{r.name}</span>
    </nav>
  );
}
